import { IApplicationState } from '../../types/redux';

export const selectListingMlRanking = (state: IApplicationState) => {
  return state.listingOffers.mlRanking;
};
